// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1mxAS","dragIcon":"SortableItem_dragIcon__3tFXT","disabled":"SortableItem_disabled__38fCk"};